<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="title">3天CP·爱在进行时</div>
      <div class="declaration">
        希望你遇到一个清风明月般的人<br>不怕岁月蹉跎<br>不怕路途遥远<br>只要最后是你就好
      </div> -->
      <img class="pic-title" src="https://static.huiyiji520.com/cppic-1661943120.png">
      <img class="pic-declaration" src="https://static.huiyiji520.com/cppic-1661234545.png">
      <div class="btn flex-box" @click="showPayPop()">提交匹配</div>
      <div class="btn flex-box modify" @click="goBack()">返回修改</div>
      <div class="instruction flex-box">
        <van-checkbox class="checkbox" v-model="checked" shape="square" icon-size="13">我已阅读并同意</van-checkbox>
        <div class="instruction-hint">
          <span class="instruction-title" @click="goUserProtocal()">《用户协议》</span>、<span class="instruction-title" @click="goPrivacyRule()">《隐私及个人信息指引》</span>
        </div>
      </div>
      <van-popup class="pop" v-model="showPop" round position="center" :close-on-click-overlay="false">
        <div>
          <!-- <div class="ptitle">报名成功</div> -->
          <img class="pic-ptitle" src="https://static.huiyiji520.com/cppic-1661235465.png">
          <img class="qrcode" src="https://static.huiyiji520.com/cppic-1661861574.jpeg">
          <div class="hints">
            <div class="hint">↑长按识别上方二维码</div>
            <div class="hint">关注公众号：<span class="account">浪漫员Club</span></div>
            <div class="hint">即可查看CP匹配结果</div>
            <div class="hint small">匹配结果公布日期：<span class="date">{{$store.state.timeLookup}}</span></div>
          </div>
          <!-- <div class="btn-confirm" @click="confirmSubmit()">确认</div> -->
        </div>
      </van-popup>

      <van-popup v-model="loading" class="pop-loading">
        <div class="loading">
          <span>正在拼命加载中，请稍等片刻～</span>
          <van-loading type="spinner" />
        </div>
      </van-popup>

      <van-popup class="pop-pay" v-model="showPayItems" position="bottom">
        <div>
          <div class="payway-title">选择入场方式</div>
          <div>
            <div class="price-item flex-box" :style="{'background': getPayItemBackground('basic'), 'borderColor': getBorderColor('basic')}" @click="pickPayItem('basic')">
              <div class="flex-box">
                <div :style="{'color': getPayPriceColor('basic')}">标准入场：{{priceBasic}}元</div>
                <div class="tags flex-box">
                  <div class="tag" :style="{'color': getPayTagColor('basic'), 'borderColor': getPayTagBorderColor('basic')}">标准模式</div>
                </div>
              </div>
              <img class="icon-check" v-if="!checkedPayBasic" src="https://static.huiyiji520.com/icon-circle-c0bebe-1667907777.png">
              <img class="icon-check" v-if="checkedPayBasic" src="https://static.huiyiji520.com/icon-check-eb8e80-1667907921.png">
            </div>
            <div class="price-item flex-box" :style="{'background': getPayItemBackground('prior'), 'borderColor': getBorderColor('prior')}" @click="pickPayItem('prior')">
              <div class="flex-box">
                <div :style="{'color': getPayPriceColor('prior')}">优先入场：{{pricePrior}}元</div>
                <div class="tags flex-box">
                  <div class="tag" :style="{'color': getPayTagColor('prior'), 'borderColor': getPayTagBorderColor('prior')}">优先匹配</div>
                  <div class="tag" :style="{'color': getPayTagColor('prior'), 'borderColor': getPayTagBorderColor('prior')}">98%完成匹配</div>
                </div>
              </div>
              <img class="icon-check" v-if="!checkedPayPrior" src="https://static.huiyiji520.com/icon-circle-c0bebe-1667907777.png">
              <img class="icon-check" v-if="checkedPayPrior" src="https://static.huiyiji520.com/icon-check-eb8e80-1667907921.png">
            </div>
            <div v-if="gender_referal != 'female-lang3dayscp_gdt' " class="price-item flex-box" :style="{'background': getPayItemBackground('membership'), 'borderColor': getBorderColor('membership')}" @click="pickPayItem('membership')">
              <div>
                <div class="flex-box">
                  <div :style="{'color': getPayPriceColor('membership')}">超级入场：{{priceMembership}}元</div>
                  <div class="tags flex-box">
                    <div class="tag" :style="{'color': getPayTagColor('membership'), 'borderColor': getPayTagBorderColor('membership')}">优先匹配</div>
                    <div class="tag" :style="{'color': getPayTagColor('membership'), 'borderColor': getPayTagBorderColor('membership')}">可参加3期</div>
                  </div>
                </div>
                <div class="price-remark" :style="{'color': getPayPriceColor('membership')}">• 可以参加3期活动，每期都享有优先匹配权，剩余未使用期数随时可退。</div>
              </div>
              <img class="icon-check" v-if="!checkedPayMember" src="https://static.huiyiji520.com/icon-circle-c0bebe-1667907777.png">
              <img class="icon-check" v-if="checkedPayMember" src="https://static.huiyiji520.com/icon-check-eb8e80-1667907921.png">
            </div>
          </div>
          <div class="pay-confirm" @click="payConfirm()">确认并支付</div>
        </div>
      </van-popup>

      <van-popup v-model="showCoupon" class="coupon-popup">
        <div class="coupon">
          <div class="coupon-reveiver">
            <div class="coupon-title">新人优惠券</div>
            <!-- <div class="coupon-price">¥ <span class="num">10</span></div> -->
            <div class="coupon-price"><span class="num">随机立减</span></div>
            <div class="coupon-hint">适用于：3天CP第{{$store.state.issue}}期</div>
            <div class="coupon-validity">有效期至：{{ $store.state.timePayDeadline }}</div>
            <div class="coupon-button" @click="activeCoupon()">立即领取</div>
          </div>
        </div>
      </van-popup>

    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Popup, Checkbox, Loading, Icon } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Loading.name]: Loading,
    [Icon.name]: Icon
  },
  data(){
    return {
      showPop: false,
      checked: true,
      loading: false,
      showPayItems: false,
      checkedPayBasic: false,
      checkedPayPrior: false,
      checkedPayMember: false,
      pickedPayItems: [],
      priceBasic: 39.9,
      pricePrior: 49.9,
      priceMembership: 129,
      gender_referal: `${this.$store.state.cpchoose.mySex}-${this.$store.state.referal}`,
      showCoupon: false,
      couponClicked: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goUserProtocal(){
      this.handleRouter('/rules_user_protocal')
    },
    goPrivacyRule(){
      this.handleRouter('/rules_privacy')
    },
    showPayPop(){
      if(!this.checked){
        Toast('请先同意《用户协议》')
      }else if(this.$store.state.userinfo.paid == 0){
        this.loading = true
        let openid = this.$store.state.userinfo.openid
        this.$api.get('/couple/check_user_cp_limit', {openid: openid}, res => {
          if(res.code == 200){
            if(res.limit == 0){
              this.loading = false
              this.showPayItems = true
            }else{
              this.submitFree()
            }
          }else{
            Toast('网络异常，请稍后再试～')
          }
        })
      }else{
        this.submit()
      }
    },
    payConfirm(){
      if( this.pickedPayItems.length == 0 ){
        Toast('请选择入场方式')
      }else{
        this.submit()
      }
    },
    submit(){
      // Toast('报名时间已截止，下次早点来哦～')
      if(this.loading){
        return
      }else if(!this.checked){
        Toast('请先同意《用户协议》')
      }else if(this.$store.state.userinfo.paid == 1){
        this.loading = true
        let openid = this.$store.state.userinfo.openid
        let cpchoose = this.$store.state.cpchoose
        if(!cpchoose.mySex){
          Toast('未选择你的性别')
          return
        }
        if(!cpchoose.myBirth){
          Toast('未选择你的年龄')
          return
        }
        if(!cpchoose.myCity){
          Toast('未选择你的城市')
          return
        }
        if(!cpchoose.myJob){
          Toast('未选择你的状态')
          return
        }
        // if(!cpchoose.myEducation){
        //   Toast('请选择你的学历')
        //   return
        // }
        if(!cpchoose.myIntro){
          Toast('未填写自我介绍')
          return
        }
        if(!cpchoose.myPhone){
          Toast('未填写你的手机号')
          return
        }
        if(!cpchoose.myWechat){
          Toast('未填写你的微信号')
          return
        }
        // if(!cpchoose.partnerSex){
        //   Toast('未选择TA的性别')
        //   return
        // }
        if(!cpchoose.partnerAge){
          Toast('未选择TA的年龄')
          return
        }
        if(!cpchoose.partnerCity){
          Toast('未选择TA的城市')
          return
        }
        if(!cpchoose.partnerJob){
          Toast('未选择TA的状态')
          return
        }
        if(!cpchoose.partnerSurprise){
          Toast('未选择是否愿意打破标准')
          return
        }
        this.$api.post('/couple/edit_form', {openid: openid, fid: cpchoose.fid, sex: cpchoose.mySex, birth: cpchoose.myBirth, province: cpchoose.myProvince, city: cpchoose.myCity, job: cpchoose.myJob, education: cpchoose.myEducation, intro: cpchoose.myIntro, tags: cpchoose.myTags, phone: cpchoose.myPhone, wechat: cpchoose.myWechat, cp_sex: cpchoose.partnerSex, cp_age: cpchoose.partnerAge, cp_city: cpchoose.partnerCity, cp_job: cpchoose.partnerJob, cp_surprise: cpchoose.partnerSurprise}, res => {
          if(res.code == 200){
            this.loading = false
            Toast('提交成功！')
            this.showPop = true
            this.$store.commit('updatSubmitted', { submitted: 1 })
          }else{
            this.loading = false
            // Toast(`openid: ${openid}, fid: ${cpchoose.fid}, sex: ${cpchoose.mySex}, birth: ${cpchoose.myBirth}, province: ${cpchoose.myProvince}, city: ${cpchoose.myCity}, job: ${cpchoose.myJob}, education: ${cpchoose.myEducation}, intro: ${cpchoose.myIntro}, tags: ${cpchoose.myTags}, phone: ${cpchoose.myPhone}, wechat: ${cpchoose.myWechat}, cp_sex: ${cpchoose.partnerSex}, cp_age: ${cpchoose.partnerAge}, cp_city: ${cpchoose.partnerCity}, cp_job: ${cpchoose.partnerJob}, cp_surprise: ${cpchoose.partnerSurprise}`)
            Toast(res.msg)
          }
        })
      }else{
        this.loading = true
        let openid = this.$store.state.userinfo.openid
        let cpchoose = this.$store.state.cpchoose
        let issue = this.$store.state.issue
        let referal = this.$store.state.referal
        let level = this.pickedPayItems[0]
        let coupon = this.$store.state.coupon
        if(!cpchoose.mySex){
          Toast('未选择你的性别')
          return
        }
        if(!cpchoose.myBirth){
          Toast('未选择你的年龄')
          return
        }
        if(!cpchoose.myCity){
          Toast('未选择你的城市')
          return
        }
        if(!cpchoose.myJob){
          Toast('未选择你的状态')
          return
        }
        // if(!cpchoose.myEducation){
        //   Toast('请选择你的学历')
        //   return
        // }
        if(!cpchoose.myIntro){
          Toast('未填写自我介绍')
          return
        }
        if(!cpchoose.myPhone){
          Toast('未填写你的手机号')
          return
        }
        if(!cpchoose.myWechat){
          Toast('未填写你的微信号')
          return
        }
        // if(!cpchoose.partnerSex){
        //   Toast('未选择TA的性别')
        //   return
        // }
        if(!cpchoose.partnerAge){
          Toast('未选择TA的年龄')
          return
        }
        if(!cpchoose.partnerCity){
          Toast('未选择TA的城市')
          return
        }
        if(!cpchoose.partnerJob){
          Toast('未选择TA的状态')
          return
        }
        if(!cpchoose.partnerSurprise){
          Toast('未选择是否愿意打破标准')
          return
        }
        this.$api.post('/couple/pay_with_membership_and_coupon', {
          openid: openid, sex: cpchoose.mySex, birth: cpchoose.myBirth, province: cpchoose.myProvince, city: cpchoose.myCity, job: cpchoose.myJob, education: cpchoose.myEducation,  intro: cpchoose.myIntro, tags: cpchoose.myTags, phone: cpchoose.myPhone, wechat: cpchoose.myWechat, cp_sex: cpchoose.partnerSex, cp_age: cpchoose.partnerAge, cp_city: cpchoose.partnerCity, cp_job: cpchoose.partnerJob, cp_surprise: cpchoose.partnerSurprise, issue: issue, referal: referal, level: level, coupon: coupon
        }, res => {
         if(res.code == 200){
           // console.log('res :' + res)
           this.loading = false
           let _this = this
           wx.chooseWXPay({
             timestamp: res.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
             nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
             package: res.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
             signType: res.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
             paySign: res.paySign, // 支付签名
             success: function (payRes) {
               // 支付成功后的回调函数
               // alert("pay success: " + JSON.stringify(payRes));
               _this.$store.commit('updatePayStatus', { paid: 1 })
               _this.$store.commit('updatSubmitted', { submitted: 1 })
               _this.showPayItems = false
               _this.showPop = true
             },
             fail: function (payErr){
               // alert("pay fail: " + JSON.stringify(payErr));
               // alert("pay res: " + JSON.stringify(res))
             }
           })
         }else{
           this.loading = false
           Toast(res.msg)
         }
        })
      }
    },
    confirmSubmit(){
      this.handleRouter('/entry_waiting')
      // this.$router.replace('/entry_waiting')
    },
    submitFree(){
      this.loading = true
      let openid = this.$store.state.userinfo.openid
      let cpchoose = this.$store.state.cpchoose
      let issue = this.$store.state.issue
      let referal = this.$store.state.referal
      if(!cpchoose.mySex){
        Toast('未选择你的性别')
        return
      }
      if(!cpchoose.myBirth){
        Toast('未选择你的年龄')
        return
      }
      if(!cpchoose.myCity){
        Toast('未选择你的城市')
        return
      }
      if(!cpchoose.myJob){
        Toast('未选择你的状态')
        return
      }
      // if(!cpchoose.myEducation){
      //   Toast('请选择你的学历')
      //   return
      // }
      if(!cpchoose.myIntro){
        Toast('未填写自我介绍')
        return
      }
      if(!cpchoose.myPhone){
        Toast('未填写你的手机号')
        return
      }
      if(!cpchoose.myWechat){
        Toast('未填写你的微信号')
        return
      }
      // if(!cpchoose.partnerSex){
      //   Toast('未选择TA的性别')
      //   return
      // }
      if(!cpchoose.partnerAge){
        Toast('未选择TA的年龄')
        return
      }
      if(!cpchoose.partnerCity){
        Toast('未选择TA的城市')
        return
      }
      if(!cpchoose.partnerJob){
        Toast('未选择TA的状态')
        return
      }
      if(!cpchoose.partnerSurprise){
        Toast('未选择是否愿意打破标准')
        return
      }
      this.$api.post('/couple/enroll_by_membership_quick_patch', {
        openid: openid, sex: cpchoose.mySex, birth: cpchoose.myBirth, province: cpchoose.myProvince, city: cpchoose.myCity, job: cpchoose.myJob, education: cpchoose.myEducation, intro: cpchoose.myIntro, tags: cpchoose.myTags, phone: cpchoose.myPhone, wechat: cpchoose.myWechat, cp_sex: cpchoose.partnerSex, cp_age: cpchoose.partnerAge, cp_city: cpchoose.partnerCity, cp_job: cpchoose.partnerJob, cp_surprise: cpchoose.partnerSurprise, issue: issue, referal: referal
      }, res => {
       if(res.code == 200){
         // console.log('res :' + res)
         this.loading = false
         this.$store.commit('updatePayStatus', { paid: 1 })
         this.$store.commit('updatSubmitted', { submitted: 1 })
         this.showPop = true
       }else{
         this.loading = false
         Toast(res.msg)
       }
      })
    },
    wxConfigInit(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/couple/get_wx_js_config_couple', {url: window.location.href, openid: openid}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
          });
        }
      })
    },
    goLangClub(){
      let url = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg5Njg0MjQyMA==&scene=123#wechat_redirect"
      window.location.href = url
    },
    getPayItemBackground(level){
      return this.pickedPayItems.includes(level) ? '#f8e5e3' : '#f7f7f7'
    },
    getBorderColor(level){
      return this.pickedPayItems.includes(level) ? '#eb8e80' : '#f7f7f7'
    },
    getPayPriceColor(level){
      return this.pickedPayItems.includes(level) ? '#eb705e' : '#737373'
    },
    getPayTagColor(level){
      return this.pickedPayItems.includes(level) ? '#eb8e80' : '#8d8b8b'
    },
    getPayTagBorderColor(level){
      return this.pickedPayItems.includes(level) ? '#eb8e80' : '#c0bebe'
    },
    pickPayItem(level){
      this.pickedPayItems.pop()
      this.pickedPayItems.push(level)
      if(level == "basic"){
        this.checkedPayBasic = true
        this.checkedPayPrior = false
        this.checkedPayMember = false
      }else if(level == "prior"){
        this.checkedPayBasic = false
        this.checkedPayPrior = true
        this.checkedPayMember = false
      }else if(level == "membership"){
        this.checkedPayBasic = false
        this.checkedPayPrior = false
        this.checkedPayMember = true
      }
    },
    getEntryPrice(){
      let gender = this.$store.state.cpchoose.mySex
      // console.log('gender: ' + gender)
      // if(gender == "female"){
      //   this.priceBasic = 29.9
      //   this.pricePrior = 39.9
      //   this.priceMembership = 99
      // }else{
      //   this.priceBasic = 39.9
      //   this.pricePrior = 49.9
      //   this.priceMembership = 129
      // }
      let openid = this.$store.state.userinfo.openid
      let referal = this.$store.state.referal
      this.$api.get('/couple/get_user_enroll_prices_with_referal', {openid: openid, sex: gender, referal: referal}, res => {
        if(res.code == 200){
          this.priceBasic = res.prices.basic
          this.pricePrior = res.prices.prior
          this.priceMembership = res.prices.membership
          if( (gender == "male" && res.prices.newbee == 1 && this.couponClicked == false) || (gender == "female" && referal == 'lang3dayscp_gdt' && this.couponClicked == false) ){
            this.showCoupon = true
          }
        }
      })
    },
    activeCoupon(){
      // Toast('成功领取优惠券！')
      this.showCoupon = false
      this.couponClicked = true
    }
  },
  mounted(){
    this.wxConfigInit()
    this.getEntryPrice()
  },
  activated() {
    this.getEntryPrice()
    this.$report.submit('/entry_submit', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661178636.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .title{margin-top:200px;margin-bottom:113px;font-size:70px;color:#eb8e80;}
.main .declaration{font-size:40px;line-height:80px;color:#737373;margin-bottom:113px;}
.main .pic-title{width:202px;height:65px;margin:0 auto;margin-top:150px;margin-bottom:120px;}
.main .pic-declaration{width:584px;height:342px;margin:0 auto;margin-bottom:110px;}
.main .btn{
  width:342px;height:90px;font-size:40px;border:5px solid #f1b8af;border-radius:30px;
  margin:0px auto;color:#ffffff;background:#f1b8af;justify-content:center;
}
.main .btn.modify{margin-top:53px;background:#fff;color:#eb8e80;}
.main .instruction{
  font-size:24px;color:#000;position:fixed;bottom:66px;padding:0px 15px;padding-left:30px;
  align-items:center;
}
/* .main .instruction .checkbox{margin-right:18px;} */
/* .main .instruction .instruction-hint{margin-left:15px;text-align: left;} */
.main .instruction .instruction-title{color:#eb8e80;}
.main .pop{width:600px;padding:50px;}
.main .pop .ptitle{font-size:78px;color:#eb8e80;margin-top:50px;}
.main .pop .pic-ptitle{width:276px;height:69px;margin:0 auto;margin-top:50px;}
.main .pop .qrcode{width:280px;display:block;margin:0 auto;margin-top:20px;margin-bottom:20px;}
.main .pop .hints{font-size:32px;color:#545454;}
.main .pop .hints .hint{margin-bottom:15px;}
.main .pop .hints .hint.small{font-size:24px;padding-top:5px;color:#737373;}
.main .pop .date{color:#eb8e80;font-weight:bold;}
.main .pop .account{color:#67a1f0;font-weight:bold;}
.main .pop .keyword{color:#eb8e80;}
.main .pop .btn-confirm{
  background:#f1b8af;color:#fff;font-size:32px;width:180px;margin:0 auto;padding:10px;
  border-radius:25px;margin-top:48px;font-weight:bold;
}
.main .pop-loading{width:70%;padding:20px;background:rgba(255,255,255,0);color:#fff;font-size:28px;}
.main .pop-pay{font-size:32px;padding:20px;color:#737373;font-weight:normal;}
.main .pop-pay .payway-title{margin-bottom:25px;}
.main .pop-pay .price-item{
  background:#f7f7f7;margin-bottom:25px;padding:25px 20px;color:#737373;font-size:28px;
  justify-content:space-between;border-radius:10px;border:4px solid #f7f7f7;
}
.main .pop-pay .price-item .icon-check{width:45px;height:45px;}
.main .pop-pay .tag{font-size:20px;margin-left:15px;background:#fff;color:#8d8b8b;padding:2px 8px;border-radius:10px;border:2px solid #c0bebe;}
.main .pop-pay .price-remark{font-size:20px;text-align:left;padding-right:20px;margin-top:10px;}
.main .pop-pay .pay-confirm{background:#eb8e80;color:#fbfbfb;padding:20px;border-radius:10px;}

.coupon-popup{
  width:454px;
  height:536px;
  background-color:rgba(0,0,0,0);
}
.coupon{
  background-image: url(https://static.langmanyuan.com/cp-coupon-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  width:100%;
  height:100%;
}
.coupon-reveiver{
  padding-top:80px;
  padding-left:80px;
  padding-right:80px;
}
.coupon-title{
  text-align:center;
  color:#666;
  font-size:24px;
}
.coupon-price{
  font-size:32px;
  color:#fe4e45;
  font-weight:bold;
}
.coupon-price .num{
  font-size:56px;
  margin-left:10px;
}
.coupon-hint{
  font-size:24px;
  color:#fe4e45;
  font-weight:lighter;
}
.coupon-validity{
  color:#ae0504;
  font-size:24px;
  margin-top:50px;
}
.coupon-button{
  background-image: linear-gradient(0deg,#ffc83a,#ffe900);
  color:#752528;
  padding:10px 0px;
  font-size:28px;
  margin-top:80px;
  border-radius:30px;
}
</style>
